import React from "react";
export class RupeeIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { active, className } = this.props;
        const fill = active ? "#C20000" : "#373435";
        return (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" className={className}>
				<path fill={fill} fillRule="nonzero" d="M6.74 9.12a.94.94 0 0 0 1.88 0 .5.5 0 0 1 1 0 1.94 1.94 0 0 1-3.88 0v-.96a.94.94 0 0 0-.94-.94.5.5 0 0 1 0-1c1.13 0 2.064-.705 2.314-1.64H2.4a.5.5 0 0 1 0-1h4.714C6.864 2.645 5.93 1.94 4.8 1.94H2.4a.5.5 0 0 1 0-1H9.36a.5.5 0 0 1 0 1H7.274c.446.444.755 1.01.864 1.64H9.36a.5.5 0 0 1 0 1H8.138c-.177 1.029-.89 1.886-1.86 2.324.288.339.462.777.462 1.256v.96z"/>
			</svg>);
    }
}
